import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { cssMainSelector } from "../lib/cssSelectors";
import { withTranslation } from "react-i18next";
import Image from "./Image";
import MediaContainer from "./MediaContainer";

const Container = styled.div`
  ${p => cssMainSelector(p.theme.tdsId)} {
    margin: 0px;
  }
`;

const ImageWrapper = styled.div`
  ${p => cssMainSelector(p.theme.tdsId)} {
    display: block;

    img {
      display: block;
      margin-left: auto;
      margin-right: auto;
      max-height: 35px;
    }
  }

  ${p => cssMainSelector(p.theme.tdsId, { mediaSizeName: "smtablet-down" })} {
    display: none;
  }
`;

const MobileImageWrapper = styled.div`
  ${p => cssMainSelector(p.theme.tdsId)} {
    display: none;

    img {
      display: block;
      margin-left: auto;
      margin-right: auto;
      max-height: 30px;
    }
  }

  ${p => cssMainSelector(p.theme.tdsId, { mediaSizeName: "smtablet-down" })} {
    display: block;
  }
`;

class CreditWarning extends PureComponent {
  render() {
    const { portal, t } = this.props;

    if (portal.showCreditWarning)
      return (
        <Container>
          <MediaContainer>
            <MobileImageWrapper>
              <Image
                responsive={true}
                src={portal.id + "/balk_afm2.jpg"}
                alt={t("creditWarning")}
              />
            </MobileImageWrapper>
            <ImageWrapper>
              <Image
                responsive={true}
                src={portal.id + "/balk_afm1.jpg"}
                alt={t("creditWarning")}
              />
            </ImageWrapper>
          </MediaContainer>
        </Container>
      );
    else return null;
  }
}

CreditWarning.propTypes = {
  portal: PropTypes.object.isRequired
};

export default withTranslation(["creditWarning"])(CreditWarning);
